<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" width="60%">
            <div>
                <!-- HTTP -->
                <h4>基本信息</h4>
                <el-divider></el-divider>
                <el-form :inline="true" :model="detailData" class="demo-form-inline" style="margin-left: 30px;">
                    <el-form-item label="规则名称">
                        <el-input v-model="detailData.ruleName" :readonly="true"></el-input>
                    </el-form-item>
                    <el-form-item label="执行设备数">
                        <el-input v-model="detailData.totalNum" :readonly="true"></el-input>
                    </el-form-item>
                    <el-form-item label="进行中设备数">
                        <el-input :readonly="true" v-model="detailData.progressNum"></el-input>
                    </el-form-item>
                    <el-form-item label="成功设备数">
                        <el-input v-model="detailData.successNum" :readonly="true"></el-input>
                    </el-form-item>
                    <el-form-item label="失败设备数">
                        <el-input :readonly="true" v-model="detailData.failNum"></el-input>
                    </el-form-item>
                    <el-form-item label="规则描述">
                        <el-input :readonly="true" v-model="detailData.ruleRemark"></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-input :readonly="true" v-model="logStatus[detailData.logStatus]"></el-input>
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <el-input :readonly="true" v-model="detailData.createDate"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div>
                <h4>规则信息</h4>
                <el-divider></el-divider>
                <div style="margin-left: 30px;">
                    <h6>触发条件</h6>
                    <el-divider></el-divider>
                    <el-form :inline="true" :model="triggerJson" class="demo-form-inline">
                        <el-form-item label="触发类型">
                            <el-input v-model="type[triggerJson.type]" :readonly="true" style="width: 180px;"></el-input>
                        </el-form-item>
                        <el-form-item label="设备名称">
                            <el-input v-model="triggerJson.devName" :readonly="true" style="width: 280px;"></el-input>
                        </el-form-item>
                        <div v-if="triggerJson.type==1">
                            <el-form-item label="指标名称">
                                <el-input v-model="triggerJson.fieldName" :readonly="true" style="width: 180px;"></el-input>
                            </el-form-item>
                            <el-form-item label="触发值">
                                <el-input v-model="triggerJson.triggerValue" :readonly="true"
                                    style="width: 180px;"></el-input>
                            </el-form-item>
                            <span v-show="triggerJson.checkOperate != 8">
                                <el-form-item label="触发条件">
                                    <el-input v-model="checkOperate[triggerJson.checkOperate]" :readonly="true"
                                        style="width: 120px;"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-input v-model="triggerJson.startValue" :readonly="true"
                                        style="width: 100px;"></el-input>
                                </el-form-item>
                            </span>
                            <span v-show="triggerJson.checkOperate == 8">
                                <el-form-item label="触发条件">
                                    <el-input v-model="triggerJson.startValue" :readonly="true"
                                        style="width: 100px;"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-input v-model="checkOperate[triggerJson.checkOperate]" :readonly="true"
                                        style="width: 120px;"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-input v-model="triggerJson.endValue" :readonly="true"
                                        style="width: 100px;"></el-input>
                                </el-form-item>
                            </span>
                        </div>

                    </el-form>
                </div>
                <div style="margin-left: 30px;">
                    <h6>过滤条件</h6>
                    <div>
                        <el-divider></el-divider>
                        <div v-show="triggerJson.type == 3" v-for="(item, index) in filterJson" :key="index">
                            <h6>过滤条件</h6>
                            <el-form :inline="true" :model="item" class="demo-form-inline">
                                <el-form-item>
                                    <el-input v-model="deviceType[item.type]" :readonly="true"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-input :value="item.duration + '分钟'" :readonly="true"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div v-show="triggerJson.type == 1" v-for="(item, index) in filterJson" :key="index">
                            <h6>过滤条件{{ index + 1 }}</h6>
                            <el-form :inline="true" :model="item" class="demo-form-inline">
                                <el-form-item>
                                    <el-input v-model="deviceType[item.type]" :readonly="true"></el-input>
                                </el-form-item>

                                <el-form-item label="开始时间">
                                    <el-input :value="item.startTime" :readonly="true"></el-input>
                                </el-form-item>
                                <el-form-item label="结束时间">
                                    <el-input :value="item.endTime" :readonly="true"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>

                    <el-divider></el-divider>
                </div>

                <div style="margin-left: 30px;">
                    <h6>执行动作</h6>
                    <el-divider></el-divider>
                    <div>
                        <el-table :data="resultPage" style="margin-left: 20px;">
                            <el-table-column label="序号" type="index" width="50">
                            </el-table-column>
                            <el-table-column prop="devCode" label="设备编号" width="200px" />
                            <el-table-column prop="devName" label="设备名称" width="300px" />
                            <el-table-column prop="actionType" label="执行操作" width="">
                                <template slot-scope="scope">{{ scope.row.actionType == 1 ? '设备输出' : '告警输出' }}</template>
                            </el-table-column>
                            <el-table-column prop="status" label="下发状态" width="">
                                <template slot-scope="scope">
                                    {{ scope.row.status == 0 ? '进行中' : scope.row.status == 1 ? '成功' : '失败' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="failReason" label="失败原因" width="" />
                        </el-table>
                    </div>

                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import API from "../../api/api";
export default {
    computed: {
        minute(m) {
            return m / 60 + '分'
        }
    },
    data() {
        return {
            dialogVisible: false,
            detailData: {},
            resultPage: [],
            filterJson: [], // 过滤条件
            triggerJson: {}, // 触发条件
            logStatus: {
                0: '异常',
                1: '成功',
                2: '失败'
            },
            type: {
                1: '设备触发',
                3: '离线触发'
            },
            deviceType: {
                2: '时间过滤',
                3: '状态持续时长'
            },
            checkOperate: {
                1: '>',
                2: '<',
                3: '==',
                4: '>=',
                5: '<=',
                6: '!=',
                7: 'in',
                8: 'between',
                9: 'like',
                10: 'not like'
            },

        }
    },

    mounted() {

    },
    methods: {
        show(row) {
            this.resetQuery()
            this.dialogVisible = true
            API.platformRuleLogDetail(row.id).then(res => {
                this.detailData = res.data
                this.filterJson = JSON.parse(res.data.filterJson)
                this.triggerJson = JSON.parse(res.data.triggerJson)
                this.resultPage = res.data.ruleActionLogs
                console.log(this.triggerJson)


            })
        },
        // 重置resetQuery
        resetQuery() {
            this.$nextTick(() => {
                this.detailData = {}
                this.filterJson = []
            })
        }
    },
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/views/platform/SceneLinkageLogDetail.vue